/* hottey Buybox: Kaufleiste mit Produktbild (Desktop bündig unter der rechten Spalte), Probierset vorausgewählt, Galerie-Punkte mobil */
(function () {
  if (window.__hlBbSticky) return;
  window.__hlBbSticky = true;
  var mq = window.matchMedia('(min-width: 990px)');
  function dotsCss() {
    if (document.getElementById('hl-bb-dots-css')) return;
    var st = document.createElement('style');
    st.id = 'hl-bb-dots-css';
    st.textContent = '.hl-bb__dots{position:absolute;left:50%;bottom:12px;z-index:3;display:none;gap:6px;align-items:center;padding:6px 10px;border-radius:999px;background:rgba(255,255,255,.88);transform:translateX(-50%);pointer-events:none}'
      + '.hl-bb__dots span{width:7px;height:7px;border-radius:999px;background:rgba(29,29,27,.25);transition:width .25s,background .25s}'
      + '.hl-bb__dots span.is-on{width:18px;background:#1D1D1B}'
      + '@media (max-width:989px){.hl-bb__dots{display:flex}.hl-bb__dots[hidden]{display:none}}';
    document.head.appendChild(st);
  }
  function dots(root) {
    var main = root.querySelector('[data-bb-main]');
    if (!main || main.querySelector('.hl-bb__dots')) return;
    dotsCss();
    var box = document.createElement('div');
    box.className = 'hl-bb__dots';
    box.setAttribute('aria-hidden', 'true');
    main.appendChild(box);
    var cur = null;
    function mark() {
      if (!cur || !cur.clientWidth) return;
      var i = Math.round(cur.scrollLeft / cur.clientWidth);
      Array.prototype.forEach.call(box.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function build() {
      var g = root.querySelector('.hl-bb__gal.is-on'), t = g ? g.querySelector('[data-track]') : null, n = t ? t.children.length : 0;
      if (t !== cur || box.children.length !== n) {
        cur = t; box.innerHTML = '';
        for (var i = 0; i < n; i++) box.appendChild(document.createElement('span'));
        box.hidden = n < 2;
      }
      mark();
    }
    root.querySelectorAll('[data-track]').forEach(function (t) {
      t.addEventListener('scroll', function () { if (t === cur) window.requestAnimationFrame(mark); }, { passive: true });
    });
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(build);
      root.querySelectorAll('.hl-bb__gal').forEach(function (g) { mo.observe(g, { attributes: true, attributeFilter: ['class'] }); });
    }
    window.addEventListener('resize', mark);
    build();
  }
  function init() {
    document.querySelectorAll('[data-hl-bb]').forEach(function (root) {
      dots(root);
      var bar = root.querySelector('[data-bb-sticky]'), info = root.querySelector('.hl-bb__info');
      if (!bar || !info || bar.getAttribute('data-docked-init')) return;
      bar.setAttribute('data-docked-init', '1');
      /* 3er Probierset vorauswählen, damit Buybox und Kaufleiste damit starten (nicht beim Sprung zu #bundles) */
      var trioIn = root.querySelector('.hl-bb__tier[data-tier="trio"] input');
      if (trioIn && location.hash !== '#bundles' && !trioIn.checked) trioIn.click();
      var inner = bar.querySelector('.hl-bb__sticky-in'), name = bar.querySelector('[data-bb-sticky-name]');
      var thumb = document.createElement('span');
      thumb.className = 'hl-bb__sticky-img';
      inner.insertBefore(thumb, inner.firstChild);
      function syncImg() {
        /* Name ohne angehängtes Tag (z. B. 3er Probierset + Gratis Versand) */
        var ts = root.querySelector('.hl-bb__tier.is-on .hl-bb__tier-main strong');
        if (name && ts && ts.querySelector('em') && ts.firstChild && ts.firstChild.nodeType === 3) {
          var clean = ts.firstChild.textContent.trim();
          if (clean && name.textContent !== clean) name.textContent = clean;
        }
        var im = root.querySelector('.hl-bb__tier.is-on .hl-bb__tier-img img');
        var src = im ? (im.currentSrc || im.src) : '';
        if (thumb.getAttribute('data-src') === src) return;
        thumb.setAttribute('data-src', src);
        thumb.innerHTML = src ? '<img src="' + src + '" alt="">' : '';
      }
      function place() {
        if (!mq.matches) { bar.classList.remove('is-docked'); bar.style.left = ''; bar.style.width = ''; return; }
        var r = info.getBoundingClientRect();
        bar.classList.add('is-docked');
        bar.style.left = Math.round(r.left) + 'px';
        bar.style.width = Math.round(r.width) + 'px';
      }
      if (name && 'MutationObserver' in window) new MutationObserver(syncImg).observe(name, { childList: true, characterData: true, subtree: true });
      root.addEventListener('click', function () { setTimeout(syncImg, 0); });
      window.addEventListener('resize', place);
      if (mq.addEventListener) mq.addEventListener('change', place);
      place(); syncImg();
      setTimeout(function () { place(); syncImg(); }, 600);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();